import * as Sentry from "@sentry/react";

export const sentryLog = (msg, level = 'error') => {
  if (typeof msg === 'string' && msg.toLowerCase().includes('request aborted')) {
    return; // Skip logging this error to Sentry
  }
  if (typeof msg === 'string' && msg.toLowerCase().includes("localstorage access blocked")) {
    return; // this is due to browser privacy setting or incognito mode, so no fix needed, and hence, not logging this to sentry 
  }
  if (typeof msg === 'string' && msg.toLowerCase().includes('failed to fetch (pagead2.googlesyndication.com)')) {
    return; // Filter out Google Ads fetch errors
  }
  if (typeof msg === 'string' && msg.toLowerCase().includes('opencamera failed: permission denied')) {
    return; // Filter out camera permission denied errors
  }
  if (level === 'error') {
    Sentry.captureException(new Error(`Log: ${msg}`));
  } else {
    Sentry.captureMessage(`Log: ${msg}`, level);
  }
};